import React, { Component } from 'react';
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing";
import "./Info.scss";

export default class Info extends Component {
    constructor() {
        super()
        this.state = {
            isShareActive: false
        }
        this.activateSharer = this.activateSharer.bind(this);
    }
    activateSharer() {
        this.setState({
            isShareActive: !this.state.isShareActive
        })
    }
    render() {
        return (
            <div>
                <section className="section-info">
                    <div className="padding">
                        <div className="container">
                            <div className="icons">
                                <div onClick={openNegishut} className="disable-icon"></div>
                                <div onClick={this.activateSharer} className="share">
                                    <div className={`social${(this.state.isShareActive ? " active " : "")}`}>
                                        <div onClick={shareWhatsapp} className="whatsapp"></div>
                                        <div onClick={shareFacebook} className="facebook"></div>
                                        <div onClick={shareTwitter} className="twitter"></div>
                                    </div>

                                </div>
                            </div>

                            <div className="top"></div>
                            <div className="text-top">
                                <p>כ-30,000 עולים חדשים הגיעו בשנה החולפת מכל העולם כדי לבנות את ביתם בישראל.
הם לוקחים חלק בסיפור המשותף לכולנו, משפיעים בכל תחומי החיים ותורמים למחקר, למדע, לרפואה, לכלכלה, לביטחון, לאמנות, לתרבות ולספורט</p>

                                <p>
                                    <b>
                                        פרויקט מיוחד של "ידיעות אחרונות" והסוכנות היהודית   &thinsp;
                                    </b>
                                  

                                    מזמין אתכם להפוך את הקליטה שלהם לחמה ונעימה יותר.
                                איך אתם משתלבים? הזמינו אותם.
                                זאת עשויה להיות תחילתה של ידידות מופלאה
                                    </p>
                            </div>

                            <div className="text-bold">
                      
                      בחרו את מי אתם רוצים לארח ולאיזו פעילות - אירוח אצלכם בבית, ארוחה משותפת, בילוי, שיחה או טיול - ואנחנו נחבר בינכם
                                                      </div>
                            <div className="text-bottom">
                                <p>ynet חלק מהמפגשים יתועדו ויפורסמו ב"ידיעות אחרונות" ובאתר</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Info/Info.jsx